import { render, staticRenderFns } from "./PostFormGroupPhotos.vue?vue&type=template&id=11292774&"
import script from "./PostFormGroupPhotos.vue?vue&type=script&lang=js&"
export * from "./PostFormGroupPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports